export default __webpack_public_path__ + "static/media/dcl-modal-image.6e867cb0.jpeg";